import React, {useEffect} from "react";
import Login from "./Login";
import {useTranslation} from "react-i18next";
import AuthService from "../../services/auth.service";

export default function Timeout(props) {
    const {t} = useTranslation();

    useEffect(() => {
        AuthService.resetStore();
    }, []);

    return (
        <Login authMessage={t('timeoutMsg')}/>
    );
}
